import { MaskDirective } from './mask.directive';

export const Directives = [
	MaskDirective,
];
